import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getPropertyFacilities = () =>
  fetch(
    `${API_BASE_URL}/property-facilities`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN
    }
  )
  .then(res => res.json())


export const savePropertyFacility = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/property-facilities`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editPropertyFacility = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/property-facilities/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deletePropertyFacility = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/property-facilities/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN
    }
  )
  return await res.json()
}